enum AlertType {
    message,
    success,
    failure,
    timeout,
}

export default AlertType;
